import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useField } from '@unform/core';

import { Container, Label } from './styles';

interface Props {
  name: string;
  label: string;
  placeholder?: string;
}

type InputProps = JSX.IntrinsicElements['input'] & Props;

export default function Input({
  name,
  label,
  placeholder,
  ...rest
}: InputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [hasValue, setHasValue] = useState(false);

  const { fieldName, defaultValue, registerField, error } = useField(name);

  const handleInputBlur = useCallback(() => {
    setHasValue(!!inputRef.current?.value);
    if (placeholder) setHasValue(true);
  }, [placeholder]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: ref => {
        return ref.current.value;
      },
      setValue: (ref, value) => {
        ref.current.value = value;
      },
      clearValue: ref => {
        ref.current.value = '';
      },
    });

    handleInputBlur();
  }, [fieldName, handleInputBlur, registerField]);

  return (
    <Container hasValue={!!hasValue} hasError={!!error}>
      <input
        id={fieldName}
        ref={inputRef}
        onBlur={handleInputBlur}
        defaultValue={defaultValue}
        placeholder={placeholder}
        {...rest}
      />
      <Label hasError={!!error} htmlFor={fieldName}>
        {label}
      </Label>
    </Container>
  );
}
